import { apiCall } from '../actions/api-call';
import { GetLoadingRestrictionsRequestAction, getLoadingRestrictions } from '../actions/loading-restriction';
import LoadingRestrictionService from '../../ports/LoadingRestrictionService';
import { Novel } from '../middlewares/novels';
import { Action } from '../actions';

export interface LoadingRestrictionNovels {
  getLoadingRestrictionsNovel: Novel<GetLoadingRestrictionsRequestAction, Action>;
}

export const loadingRestrictionNovelsCreator = (
  loadingRestrictionService: LoadingRestrictionService,
): LoadingRestrictionNovels => {
  const getLoadingRestrictionsNovel = async (
    {}: GetLoadingRestrictionsRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    try {
      dispatch(apiCall());
      const customsBrokers = await loadingRestrictionService.getLoadingRestrictions();
      dispatch(apiCall.success());
      dispatch(getLoadingRestrictions.success(customsBrokers));
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(getLoadingRestrictions.failure(err.message));
    }
  };

  return {
    getLoadingRestrictionsNovel,
  };
};
